// extracted by mini-css-extract-plugin
module.exports = {"spin":"ButtonSpinner_spin__2Crof","button-spinner":"ButtonSpinner_button-spinner__3M-9n"};